import { BaseEntityPage } from '../../components/common';
import { AdmissionMethodsContent } from './components';

export default function AdmissionMethodsPage() {
	return (
		<BaseEntityPage ContentComponent={AdmissionMethodsContent} />
	);
}